export const type = 'form.image';
